import { IMultiLanguage } from '@/shared/model/multi-language.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IPrice, Price } from '@/shared/model/price.model';
import { IAddonCategory } from '@/shared/model/addon-category.model';
import { IAvailability } from '@/shared/model/availability.model';
import { IMenu } from '@/shared/model/menu.model';

export interface IMenuVariant {
  id?: number;
  ordinal?: number | null;
  soldOut?: boolean | null;
  title?: IMultiLanguage | null;
  titleValue?: string | null;
  discount?: IDiscount | null;
  price?: IPrice | null;
  priceValue?: number | null;
  addonCategories?: IAddonCategory[] | null;
  availabilities?: IAvailability[] | null;
  menu?: IMenu | null;
}

export class MenuVariant implements IMenuVariant {
  constructor(
    public id?: number,
    public ordinal?: number | null,
    public soldOut?: boolean | null,
    public title?: IMultiLanguage | null,
    public titleValue?: string | null,
    public discount?: IDiscount | null,
    public price?: IPrice | null,
    public priceValue?: number | null,
    public addonCategories?: IAddonCategory[] | null,
    public availabilities?: IAvailability[] | null,
    public menu?: IMenu | null,
  ) {
    this.soldOut = this.soldOut ?? false;
    this.addonCategories = this.addonCategories ?? [];
    this.price = this.price ?? new Price();
  }
}
